import React from "react";
import {
  IoMdClose,
  IoMdShare,
  IoMdRefresh,
  IoIosAdd,
  IoIosAlert,
  IoIosArrowRoundBack,
  IoMdArrowDropdown,
  IoMdMore,
  IoMdSettings,
} from "react-icons/io";
import {
  IoInformationCircleOutline,
  IoNotificationsSharp,
  IoScan,
  IoReorderThree,
  IoPieChartOutline,
  IoLogOutOutline,
  IoClose,
  IoFootballOutline,
} from "react-icons/io5";
import {
  FaGift,
  FaHandsHelping,
  FaRegCopy,
  FaUser,
  FaFlag,
  FaQrcode,
  FaYoutube,
  FaVoteYea,
  FaCalendarAlt,
  FaLink,
  FaStar,
  FaInfoCircle,
  FaMoneyBill,
  FaLinkedin,
  FaTelegramPlane,
  FaFileDownload,
  FaRegCircle,
  FaRegSquare,
  FaRedditAlien,
  FaTwitter,
  FaInstagram,
  FaGithub,
  FaWhatsapp,
  FaCheck,
  FaRegEye,
  FaRegEyeSlash,
  FaRegStar,
  FaPlay,
  FaBell,
  FaFile,
} from "react-icons/fa";
import {
  FaArrowLeft,
  FaCirclePlay,
  FaCheckToSlot,
  FaList,
  FaArrowRightLong,
  FaArrowLeftLong,
  FaFacebookF,
  FaPlus,
  FaRegFilePdf,
  FaXTwitter,
} from "react-icons/fa6";
import {
  AiFillEye,
  AiFillEyeInvisible,
  AiOutlineUnorderedList,
  AiFillSetting,
  AiOutlineStar,
  AiFillStar,
  AiOutlineCalculator,
  AiOutlineHome,
} from "react-icons/ai";
import {
  BiLogOutCircle,
  BiDollarCircle,
  BiChevronLeft,
  BiChevronRight,
  BiChevronDown,
  BiChevronUp,
  BiGitPullRequest,
  BiSupport,
  BiSolidUserPin,
  BiPurchaseTag,
  BiSolidBank,
  BiAdjust,
  BiLogIn,
} from "react-icons/bi";
import {
  MdDashboard,
  MdDelete,
  MdEdit,
  MdOutlineManageAccounts,
  MdAccountBox,
  MdMyLocation,
  MdOutlineMilitaryTech,
  MdKeyboardArrowRight,
  MdOutlinePolicy,
  MdOutlineContactPhone,
  MdOutlinePrivacyTip,
  MdOutlineReport,
  MdMapsHomeWork,
  MdRefresh,
  MdOutlineSportsCricket,
  MdOutlineSportsTennis,
  MdOutlineGamepad,
  MdOutlineSportsBasketball,
  MdOutlineAccessTime,
  MdKeyboardArrowLeft,
  MdKeyboardArrowUp,
  MdLiveTv,
  MdAdsClick,
  MdOutlineKeyboardArrowDown,
  MdOutlineChat,
  MdSend,
} from "react-icons/md";
import {
  FiArrowRightCircle,
  FiSave,
  FiMoreVertical,
  FiSearch,
} from "react-icons/fi";
import { FcTimeline } from "react-icons/fc";
import { GrTransaction } from "react-icons/gr";
import {
  RiRefundLine,
  RiUpload2Line,
  RiFileExcel2Fill,
  RiBook2Fill,
  RiPagesFill,
  RiFileListLine,
} from "react-icons/ri";
import { VscServerProcess } from "react-icons/vsc";
import {
  TbReportAnalytics,
  TbUserSquare,
  TbAffiliate,
  TbLogout2,
  TbDeviceGamepad2,
} from "react-icons/tb";
import { ImUserCheck } from "react-icons/im";
import { LuWallet, LuClock3 } from "react-icons/lu";
import { GoArrowRight, GoDotFill } from "react-icons/go";
import {
  BsFiletypeJson,
  BsGearWideConnected,
  BsInfoSquare,
  BsChevronLeft,
  BsChevronRight,
  BsLightningChargeFill,
  BsMagic,
  BsFire,
  BsBank2,
} from "react-icons/bs";
import { LiaHorseHeadSolid } from "react-icons/lia";
import { CgFileDocument } from "react-icons/cg";
import { GiGamepadCross, GiHamburgerMenu } from "react-icons/gi";
import { PiTennisBallLight, PiLadderSimple } from "react-icons/pi";
import { CiLink, CiLock } from "react-icons/ci";
import { HiMiniArrowTopRightOnSquare } from "react-icons/hi2";
import {
  HiBadgeCheck,
  HiChevronRight,
  HiOutlineExclamation,
} from "react-icons/hi";
import { CgMathPlus } from "react-icons/cg";
import { CgMathMinus } from "react-icons/cg";

export const reactIcons = {
  alert: <IoIosAlert />,
  save: <FiSave />,
  logout: <BiLogOutCircle />,
  dollar: <BiDollarCircle />,
  list: <AiOutlineUnorderedList />,
  arrowleft: <BiChevronLeft />,
  arrowright: <BiChevronRight />,
  arrowDown: <BiChevronDown />,
  arrowUp: <BiChevronUp />,
  dashboard: <MdDashboard />,
  setting: <AiFillSetting />,
  edit: <MdEdit />,
  delete: <MdDelete />,
  manage: <MdOutlineManageAccounts />,
  gift: <FaGift />,
  star: <AiOutlineStar />,
  fillstar: <AiFillStar />,
  eyeVisible: <AiFillEye />,
  eyeInVisible: <AiFillEyeInvisible />,
  close: <IoMdClose />,
  copy: <FaRegCopy />,
  handShake: <FaHandsHelping />,
  timeline: <FcTimeline />,
  transactions: <GrTransaction />,
  request: <BiGitPullRequest />,
  flag: <FaFlag />,
  qrCode: <FaQrcode />,
  account: <MdAccountBox />,
  upload: <RiUpload2Line />,
  more: <FiMoreVertical />,
  moreItems: <IoMdMore />,
  location: <MdMyLocation />,
  process: <VscServerProcess />,
  TbReportAnalytics: <TbReportAnalytics />,
  calculater: <AiOutlineCalculator />,
  userCheck: <ImUserCheck />,
  kyc: <TbUserSquare />,
  report: <MdOutlineReport />,
  wallet: <LuWallet />,
  info: <IoInformationCircleOutline />,
  leftArrow: <FaArrowLeft />,
  login: <BiSolidUserPin />,
  gear: <BsGearWideConnected />,
  refresh: <IoMdRefresh />,
  check: <FaCheck />,
  purchase: <BiPurchaseTag />,
  toggle: <IoReorderThree />,
  affiliate: <TbAffiliate />,
  franchise: <MdMapsHomeWork />,
  excell: <RiFileExcel2Fill />,
  starFill: <FaStar />,
  infoFill: <FaInfoCircle />,
  disconnect: <TbLogout2 />,
  fraction: <IoPieChartOutline />,
  add: <IoIosAdd />,
  bank: <BiSolidBank />,
  reward: <MdOutlineMilitaryTech />,
  notification: <IoNotificationsSharp />,
  support: <BiSupport />,
  ioScan: <IoScan />,
  linkedIn: <FaLinkedin />,
  telegram: <FaTelegramPlane />,
  whatsapp: <FaWhatsapp />,
  ads_click: <MdAdsClick />,
  square: <FaRegSquare />,
  circle: <FaRegCircle />,
  plus: <FaPlus />,
  dropArrow: <IoMdArrowDropdown />,
  longRight: <FaArrowRightLong />,
  fb: <FaFacebookF />,
  git: <FaGithub />,
  instagram: <FaInstagram />,
  longLeft: <FaArrowLeftLong />,
  dummy: <BiAdjust />,
  refresh1: <MdRefresh />,
  twitter: <FaTwitter />,
  list1: <FaList />,
  withdraw: <RiPagesFill />,
  book: <RiBook2Fill />,
  money: <FaMoneyBill />,
  bigLeft: <FaArrowLeft />,
  bank: <BsBank2 />,
  user: <FaUser />,
  home: <AiOutlineHome />,
  lock: <CiLock />,
  ladder: <PiLadderSimple />,
  fireClock: <LuClock3 />,
  file: <RiFileListLine />,
  fire: <BsFire />,
  tv: <MdLiveTv />,
  play2: <FaPlay />,
  hamburger: <GiHamburgerMenu />,
  logout: <IoLogOutOutline />,
  login: <BiLogIn />,
  dot: <GoDotFill />,
  downArrow: <MdOutlineKeyboardArrowDown />,
  upArrow: <MdKeyboardArrowUp />,
  lightning: <BsLightningChargeFill />,
  star: <FaRegStar />,
  play: <FaCirclePlay />,
  casino: <GiGamepadCross />,
  cricket: <MdOutlineSportsCricket />,
  football: <IoFootballOutline />,
  tennis: <PiTennisBallLight />,
  search: <FiSearch />,
  close: <IoClose />,
  watch: <MdOutlineAccessTime />,
  arrowleft: <BsChevronLeft />,
  arrowright: <BsChevronRight />,
  checkMark: <FaCheck />,
  eye: <FaRegEye />,
  eyeSlash: <FaRegEyeSlash />,
  tenis: <MdOutlineSportsTennis />,
  vgame: <MdOutlineGamepad />,
  basketball: <MdOutlineSportsBasketball />,
  horse: <LiaHorseHeadSolid />,
  egame: <TbDeviceGamepad2 />,
  politics: <CgFileDocument />,
  slot: <FaCheckToSlot />,
  magic: <BsMagic />,
  pdf: <FaRegFilePdf />,
  back: <IoIosArrowRoundBack />,
  reddit: <FaRedditAlien />,
  leftArrow: <MdKeyboardArrowLeft />,
  rightArrow: <MdKeyboardArrowRight />,
  about: <BsInfoSquare />,
  policy: <MdOutlinePolicy />,
  contact: <MdOutlineContactPhone />,
  privacy: <MdOutlinePrivacyTip />,
  refund: <RiRefundLine />,
  youtube: <FaYoutube />,
  walletArrow: <GoArrowRight />,
  goArrow: <HiMiniArrowTopRightOnSquare />,
  vote: <FaVoteYea />,
  rightarrow: <FiArrowRightCircle />,
  rgtArrow: <HiChevronRight />,
  share: <IoMdShare />,
  badgeCheck: <HiBadgeCheck />,
  exclamation: <HiOutlineExclamation />,
  jsonfile: <BsFiletypeJson />,
  calendar: <FaCalendarAlt />,
  link: <FaLink />,
  linkedIn: <FaLinkedin />,
  telegram: <FaTelegramPlane />,
  whatsapp: <FaWhatsapp />,
  ads_click: <MdAdsClick />,
  square: <FaRegSquare />,
  circle: <FaRegCircle />,
  plus: <FaPlus />,
  dropArrow: <IoMdArrowDropdown />,
  longRight: <FaArrowRightLong />,
  fb: <FaFacebookF />,
  git: <FaGithub />,
  instagram: <FaInstagram />,
  longLeft: <FaArrowLeftLong />,
  dummy: <BiAdjust />,
  refresh: <MdRefresh />,
  twitter: <FaTwitter />,
  list1: <FaList />,
  withdraw: <RiPagesFill />,
  book: <RiBook2Fill />,
  money: <FaMoneyBill />,
  bigLeft: <FaArrowLeft />,
  bank: <BsBank2 />,
  user: <FaUser />,
  home: <AiOutlineHome />,
  lock: <CiLock />,
  ladder: <PiLadderSimple />,
  fireClock: <LuClock3 />,
  file: <RiFileListLine />,
  fire: <BsFire />,
  tv: <MdLiveTv />,
  play2: <FaPlay />,
  hamburger: <GiHamburgerMenu />,
  logout: <IoLogOutOutline />,
  login: <BiLogIn />,
  dot: <GoDotFill />,
  downArrow: <MdOutlineKeyboardArrowDown />,
  upArrow: <MdKeyboardArrowUp />,
  lightning: <BsLightningChargeFill />,
  star: <FaRegStar />,
  play: <FaCirclePlay />,
  casino: <GiGamepadCross />,
  cricket: <MdOutlineSportsCricket />,
  football: <IoFootballOutline />,
  tennis: <PiTennisBallLight />,
  setting: <IoMdSettings />,
  close: <IoClose />,
  watch: <MdOutlineAccessTime />,
  arrowleft: <BsChevronLeft />,
  arrowright: <BsChevronRight />,
  checkMark: <FaCheck />,
  eye: <FaRegEye />,
  eyeSlash: <FaRegEyeSlash />,
  tenis: <MdOutlineSportsTennis />,
  vgame: <MdOutlineGamepad />,
  basketball: <MdOutlineSportsBasketball />,
  horse: <LiaHorseHeadSolid />,
  egame: <TbDeviceGamepad2 />,
  politics: <CgFileDocument />,
  slot: <FaCheckToSlot />,
  magic: <BsMagic />,
  pdf: <FaRegFilePdf />,
  back: <IoIosArrowRoundBack />,
  reddit: <FaRedditAlien />,
  leftArrow: <MdKeyboardArrowLeft />,
  rightArrow: <MdKeyboardArrowRight />,
  download: <FaFileDownload />,
  plus: <CgMathPlus />,
  minus: <CgMathMinus />,
  xIcon: <FaXTwitter />,
  notificationBold: <FaBell />,
  chat: <MdOutlineChat />,
  send: <MdSend />,
  fileLogo: <FaFile />,
  link: <CiLink />,
};
